import { Route, Switch } from 'quartz-routing/react-router';
import { getPortalBasename, PortalsPlatformObjectIdProvider, PortalsAppLayout, PageNotFound, usePortalNavigation } from 'portals-platform-lib';
import { RouterProvider } from 'quartz-routing';
// @bend-expect quartz-no-create-browser-history
import { createBrowserHistory } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import { Home } from '../containers/Home';
import { Preview } from '../containers/Preview';
import { getIsPreview } from '../utils/getIsPreview';
import { useDealPlanId } from '../hooks/useDealPlanId';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NotFoundRoute() {
  var _currentSpaceNavItem$, _currentSpaceNavItem$2;
  const {
    navItems
  } = usePortalNavigation();
  const currentSpaceNavItem = navItems.find(item => item.isCurrent);
  const firstDealPlanPath = (_currentSpaceNavItem$ = currentSpaceNavItem === null || currentSpaceNavItem === void 0 || (_currentSpaceNavItem$2 = currentSpaceNavItem.children[0]) === null || _currentSpaceNavItem$2 === void 0 ? void 0 : _currentSpaceNavItem$2.href) !== null && _currentSpaceNavItem$ !== void 0 ? _currentSpaceNavItem$ : currentSpaceNavItem === null || currentSpaceNavItem === void 0 ? void 0 : currentSpaceNavItem.href;
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "NOT_FOUND_LOAD",
    children: /*#__PURE__*/_jsx(PortalsAppLayout, {
      children: /*#__PURE__*/_jsx(PageNotFound, {
        homePath: firstDealPlanPath
      })
    })
  });
}
function PortalsPlatformDealPlanIdProvider(props) {
  const dealPlanId = useDealPlanId();
  return /*#__PURE__*/_jsx(PortalsPlatformObjectIdProvider, {
    objectId: dealPlanId,
    children: props.children
  });
}
export function Routes() {
  var _getPortalBasename;
  // Get dynamic basename from portal metadata
  // Falls back to /deal-plan if not in a portal context (e.g., local dev without proxy)
  const history = createBrowserHistory({
    basename: (_getPortalBasename = getPortalBasename()) !== null && _getPortalBasename !== void 0 ? _getPortalBasename : '/deal-plan'
  });
  if (getIsPreview()) {
    return /*#__PURE__*/_jsx(RouterProvider, {
      history: history,
      children: /*#__PURE__*/_jsx(Preview, {})
    });
  }
  return /*#__PURE__*/_jsx(RouterProvider, {
    history: history,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/:dealPlanId",
        exact: true,
        children: /*#__PURE__*/_jsx(PortalsPlatformDealPlanIdProvider, {
          children: /*#__PURE__*/_jsx(Home, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        children: /*#__PURE__*/_jsx(NotFoundRoute, {})
      })]
    })
  });
}